import { $qs , $qsa } from "./utils/querySelector"
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

function scrollVideo () {
    if($qs('[data-target=scroll-video-container]')) {
        const video = $qs("[data-target=scroll-video]");
        let introTitle = $qs("[data-target=scroll-video-intro-title]");
        let introText = $qs("[data-target=scroll-video-intro-text]");
        let src = video.currentSrc || video.src;        
        // video.pause();
        /* Make sure the video is 'activated' on iOS */
        function once(el, event, fn, opts) {
          var onceFn = function (e) {
            el.removeEventListener(event, onceFn);
            fn.apply(this, arguments);
          };
          el.addEventListener(event, onceFn, opts);
          return onceFn;
        }

        // once(document.documentElement, "touchstart", function (e) {
        //   video.play();
        //   video.pause();
        // });

        /* ---------------------------------- */
        /* Scroll Control! */

        // gsap.registerPlugin(ScrollTrigger);
        var menu = $qs('.js-preloader-menu');
        let tl = gsap.timeline({
          defaults: { duration: 1 },
          scrollTrigger: {
            trigger: "#container",
            start: "top bottom",
            end: "bottom bottom",
            scrub: true,      
          },
        });

        tl.scrollTrigger.refresh();
        // remove with scroll
        tl.to(video, {
          opacity:1,          
        },">+=1")
        // once(video, "loadedmetadata", () => {
          tl.to(video, {
            scale: 0.5,
            yPercent: -150,  
            // ease:  "power4.out" ,
            duration: 4       
          }, ">") 
        tl.to('video', {
        
          onStart: () => {
            gsap.to(introTitle, {
              opacity: 1,   
              duration: 1         
            }, ">")
            gsap.to(introText, {
              opacity: 1,
              duration:1
            }, "<+=0.2")
          }                  
        }, "<+=15%")
        tl.to(menu , {
          yPercent: -100,
          duration: 0.4 
       }, "<")
      //  tl.to(menu , {
      //     position: 'relative',
      //     duration: 0.1
      //  }, ">")

        // });

        /* When first coded, the Blobbing was important to ensure the browser wasn't dropping previously played segments, but it doesn't seem to be a problem now. Possibly     based   on memory availability? */
        // setTimeout(function () {
        //   if (window["fetch"]) {
        //     fetch(src)
        //       .then((response) => response.blob())
        //       .then((response) => {
        //         var blobURL = URL.createObjectURL(response);
        //         console.log(blobURL);
        //         var t = video.currentTime;
        //         // once(document.documentElement, "touchstart", function (e) {
        //         //   video.play();
        //         //   video.pause();
        //         // });

        //         video.setAttribute("src", blobURL);
        //         video.currentTime = t + 0.01;
        //       });
        //   }
        // }, 1000);

        /* ---------------------------------- */
    }
}

export default scrollVideo;